/*
 *
 * Session constants
 *
 */



export const MY_ACCOUNT_LIST = 'app/session/MY_ACCOUNT_LIST'
export const MY_ACCOUNT_LIST_SUCCESS = 'app/session/MY_ACCOUNT_LIST_SUCCESS'
export const MY_ACCOUNT_LIST_ERROR = 'app/session/MY_ACCOUNT_LIST_ERROR'
export const DASHBOARD_ME_API = 'app/session/DASHBOARD_ME_API'
export const DASHBOARD_ME_API_SUCCESS = 'app/session/DASHBOARD_ME_API_SUCCESS'
export const DASHBOARD_ME_API_ERROR = 'app/session/DASHBOARD_ME_API_ERROR'


export const ROUTER = '@@router/LOCATION_CHANGE'


const constants = {
    
  MY_ACCOUNT_LIST,
  MY_ACCOUNT_LIST_SUCCESS,
  MY_ACCOUNT_LIST_ERROR,
  DASHBOARD_ME_API,
  DASHBOARD_ME_API_SUCCESS,
  DASHBOARD_ME_API_ERROR
}

export default constants

